"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clipsLangKey = clipsLangKey;

function clipsLangKey(key) {
  return "composer-lib.clips." + key;
}